import { z } from 'zod';

export const authErrorCodeSchema = z.enum([
  'unauthorized',
  'incorrect_totp',
  'incorrect_email_totp',
  'incorrect_sms_totp',
  'incorrect_backup_token',
  'account_inactive',
  'user_inactive',
  'challenge_unavailable',
  'challenge_expired',
  'credit_limit_exceeded',
  'invalid_token',
  'token_expired',
  'password_mismatch',
  'password_too_weak',
  'invalid_challenge_answer',
]);

export type AuthErrorCode = z.infer<typeof authErrorCodeSchema>;

export const authErrorResponseSchema = z.object({
  type: z.literal('error'),
  data: z.object({
    code: authErrorCodeSchema,
    message: z.string().optional(),
  }),
});

export type AuthErrorResponse = z.infer<typeof authErrorResponseSchema>;

export const errorMessages: Record<AuthErrorCode, string> = {
  unauthorized: 'Unable to login. Please try again. If the problem persists, contact support.',
  incorrect_totp: 'Invalid code. Please try again.',
  incorrect_email_totp: 'Invalid code. Check email and try again.',
  incorrect_sms_totp: 'Invalid code. Check phone and try again.',
  incorrect_backup_token: 'Invalid backup token. Please try again.',
  account_inactive: 'Account deactivated. Contact support.',
  user_inactive: 'User deactivated. Contact administrator.',
  challenge_unavailable: 'Method not available. Try another.',
  challenge_expired: 'Challenge expired. Please start over.',
  credit_limit_exceeded: 'Too many attempts. Wait 5 minutes.',
  invalid_token: 'Invalid token. Please try again.',
  token_expired: 'Token has expired. Please request a new one.',
  password_mismatch: 'Passwords do not match.',
  password_too_weak: 'Password is too weak. Please use a stronger password.',
  invalid_challenge_answer: 'Device trust token is invalid or expired.',
};

export function getErrorMessage(code: AuthErrorCode): string {
  return errorMessages[code] || 'An unexpected error occurred';
}
